import React from 'react';
import { Row, Col } from 'antd';
import { companyStats } from '../data/mockData';

const StatsSection = () => {
  return (
    <div className="stats-section section-padding">
      <div className="container">
        <Row gutter={[24, 24]}>
          {companyStats.map((stat, index) => (
            <Col xs={12} sm={6} key={index}>
              <div className="stats-card">
                <div className="stats-number">
                  {stat.value}
                </div>
                <div className="stats-label">
                  {stat.label}
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </div>
    </div>
  );
};

export default StatsSection;